exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-gradient {\n  background: #ccf3f9;\n  background: linear-gradient(45deg, #15a5bb 70%, #97d700 100%);\n}\n", ""]);

// exports
